// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* dynamic-checkbox-card.component.css */

:host {
  width: 100%;
  display: block;
}

.pricing-card {
  display: block;
  min-height: 160px;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.pricing-card.selected {
  transform: translateY(-4px);
}

.pricing-card:not(.disabled):not(.selected):hover {
  transform: translateY(-2px);
}

.pricing-card.disabled {
  filter: grayscale(0.5);
}

@keyframes scale-in {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

.animate-scale-in {
  animation: scale-in 0.3s ease-out;
}

/* Utility classes if not using Tailwind */
.line-clamp-2 {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImR5bmFtaWMtY2hlY2tib3gtY2FyZC5jb21wb25lbnQuY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLHdDQUF3Qzs7QUFFeEM7RUFDRSxXQUFXO0VBQ1gsY0FBYztBQUNoQjs7QUFFQTtFQUNFLGNBQWM7RUFDZCxpQkFBaUI7RUFDakIsaURBQWlEO0FBQ25EOztBQUVBO0VBQ0UsMkJBQTJCO0FBQzdCOztBQUVBO0VBQ0UsMkJBQTJCO0FBQzdCOztBQUVBO0VBQ0Usc0JBQXNCO0FBQ3hCOztBQUVBO0VBQ0U7SUFDRSxtQkFBbUI7SUFDbkIsVUFBVTtFQUNaO0VBQ0E7SUFDRSxxQkFBcUI7RUFDdkI7RUFDQTtJQUNFLG1CQUFtQjtJQUNuQixVQUFVO0VBQ1o7QUFDRjs7QUFFQTtFQUNFLGlDQUFpQztBQUNuQzs7QUFFQSwwQ0FBMEM7QUFDMUM7RUFDRSxvQkFBb0I7RUFDcEIscUJBQXFCO0VBQ3JCLDRCQUE0QjtFQUM1QixnQkFBZ0I7QUFDbEIiLCJmaWxlIjoiZHluYW1pYy1jaGVja2JveC1jYXJkLmNvbXBvbmVudC5jc3MiLCJzb3VyY2VzQ29udGVudCI6WyIvKiBkeW5hbWljLWNoZWNrYm94LWNhcmQuY29tcG9uZW50LmNzcyAqL1xuXG46aG9zdCB7XG4gIHdpZHRoOiAxMDAlO1xuICBkaXNwbGF5OiBibG9jaztcbn1cblxuLnByaWNpbmctY2FyZCB7XG4gIGRpc3BsYXk6IGJsb2NrO1xuICBtaW4taGVpZ2h0OiAxNjBweDtcbiAgdHJhbnNpdGlvbjogYWxsIDAuM3MgY3ViaWMtYmV6aWVyKDAuNCwgMCwgMC4yLCAxKTtcbn1cblxuLnByaWNpbmctY2FyZC5zZWxlY3RlZCB7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgtNHB4KTtcbn1cblxuLnByaWNpbmctY2FyZDpub3QoLmRpc2FibGVkKTpub3QoLnNlbGVjdGVkKTpob3ZlciB7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlWSgtMnB4KTtcbn1cblxuLnByaWNpbmctY2FyZC5kaXNhYmxlZCB7XG4gIGZpbHRlcjogZ3JheXNjYWxlKDAuNSk7XG59XG5cbkBrZXlmcmFtZXMgc2NhbGUtaW4ge1xuICAwJSB7XG4gICAgdHJhbnNmb3JtOiBzY2FsZSgwKTtcbiAgICBvcGFjaXR5OiAwO1xuICB9XG4gIDUwJSB7XG4gICAgdHJhbnNmb3JtOiBzY2FsZSgxLjEpO1xuICB9XG4gIDEwMCUge1xuICAgIHRyYW5zZm9ybTogc2NhbGUoMSk7XG4gICAgb3BhY2l0eTogMTtcbiAgfVxufVxuXG4uYW5pbWF0ZS1zY2FsZS1pbiB7XG4gIGFuaW1hdGlvbjogc2NhbGUtaW4gMC4zcyBlYXNlLW91dDtcbn1cblxuLyogVXRpbGl0eSBjbGFzc2VzIGlmIG5vdCB1c2luZyBUYWlsd2luZCAqL1xuLmxpbmUtY2xhbXAtMiB7XG4gIGRpc3BsYXk6IC13ZWJraXQtYm94O1xuICAtd2Via2l0LWxpbmUtY2xhbXA6IDI7XG4gIC13ZWJraXQtYm94LW9yaWVudDogdmVydGljYWw7XG4gIG92ZXJmbG93OiBoaWRkZW47XG59XG4iXX0= */`, "",{"version":3,"sources":["webpack://./src/app/shared/partials/dynamic-checkbox-card/dynamic-checkbox-card.component.css"],"names":[],"mappings":"AAAA,wCAAwC;;AAExC;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,iDAAiD;AACnD;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE;IACE,mBAAmB;IACnB,UAAU;EACZ;EACA;IACE,qBAAqB;EACvB;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE,iCAAiC;AACnC;;AAEA,0CAA0C;AAC1C;EACE,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;EAC5B,gBAAgB;AAClB;;AAEA,w0DAAw0D","sourcesContent":["/* dynamic-checkbox-card.component.css */\n\n:host {\n  width: 100%;\n  display: block;\n}\n\n.pricing-card {\n  display: block;\n  min-height: 160px;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.pricing-card.selected {\n  transform: translateY(-4px);\n}\n\n.pricing-card:not(.disabled):not(.selected):hover {\n  transform: translateY(-2px);\n}\n\n.pricing-card.disabled {\n  filter: grayscale(0.5);\n}\n\n@keyframes scale-in {\n  0% {\n    transform: scale(0);\n    opacity: 0;\n  }\n  50% {\n    transform: scale(1.1);\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n.animate-scale-in {\n  animation: scale-in 0.3s ease-out;\n}\n\n/* Utility classes if not using Tailwind */\n.line-clamp-2 {\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
